import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['clearableInput', 'response']

  clear() {
    this.clearableInputTargets.forEach((input) => {
      input.value = ''
    })
  }

  done(event) {
    this.responseTarget.innerHTML = event.detail[2].response
  }
}
